module.exports = __webpack_public_path__ + "img/subway.34921814.png";